import './index.css';
import Database from './Components/Database';

function App() {
  return (
    <Database />
  );
}
export default App;